/* eslint-disable no-unused-expressions */
/*!

=========================================================
* Paper Dashboard React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useEffect, useRef, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import {
  getUsuariosAdm,
  deleteMenu,
  updateMenu,
  createMenu,
} from "redux/actions/Screening/screeningActions";
import { connect } from "react-redux";
import {
  Nav,
  Collapse,
  Spinner,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

import PerfectScrollbar from "perfect-scrollbar";

import logo from "icon.svg";
import { Fragment } from "react";
//import withReactContent from "sweetalert2-react-content";
import { isMobile } from "react-device-detect";
import CadastrarMenu from "views/modals/cadastrar-menu";
import EditarMenu from "views/modals/editar-menu";
import DeleteMenu from "views/modals/deletar-menu";
//const MySwal = withReactContent(Swal);

var ps;
function Sidebar(props) {
  const [areaLocalStorage, setAreaLocalStorage] = React.useState(
    localStorage.getItem("area")
  );
  const [collapseStates, setCollapseStates] = React.useState({});
  const [colapseStatus, setColapseStatus] = React.useState("");
  const [openMenu, setOpenMenu] = React.useState(false);
  const [openDeleteMenu, setOpenDeleteMenu] = React.useState(false);
  const [dropdownOpen, setDropdownOpen] = React.useState(false);
  const [openEditMenu, setOpenEditMenu] = React.useState(false);
  //const user = JSON.parse(localStorage.getItem("user-profile"));
  const hasAcess = props.usuariosAdm?.length > 0;
  //const [state, setState] = React.useState();
  const sidebar = React.useRef();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [init, setInit] = useState(true);
  const location = useLocation();
  const firstLoad = useRef(true);

  useEffect(() => {
    function handleResize() {
      setWindowWidth(window.innerWidth);
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const activeRoute = (routeName, name) => {
    if (name === localStorage.getItem("idMenu")) return "active";
    else return "";
  };

  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(sidebar.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
    }
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
    };
  });
  // React.useEffect(() => {
  //   setCollapseStates(getCollapseStates(props.routes));
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  React.useEffect(() => {
    setAreaLocalStorage(localStorage.getItem("area"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localStorage.getItem("area")]);

  useEffect(() => {
    const pathSegments = location.pathname.split("/");
    const idMenu = pathSegments[4] || "";
    if (windowWidth < 650 && init && !idMenu) {
      document.documentElement.classList.toggle("nav-open", true);
      window.dispatchEvent(new CustomEvent("toggleNav"));
      setInit(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getCollapseInitialState = (routes, idMenu) => {
    for (let route of routes) {
      if (route.idMenu === idMenu) {
        return true;
      }
      if (route.views && getCollapseInitialState(route.views, idMenu)) {
        return true;
      }
    }
    return false;
  };

  const getCollapseStates = (routes, idMenu) => {
    let initialState = {};
    for (let route of routes) {
      initialState[route.state] = getCollapseInitialState(
        route.views || [],
        idMenu
      );
      if (route.views) {
        const subStates = getCollapseStates(route.views, idMenu);
        initialState = { ...initialState, ...subStates };
      }
    }
    return initialState;
  };

  useEffect(() => {
    if (firstLoad.current && props.routes && props.routes.length > 0) {
      const pathSegments = location.pathname.split("/");
      const idMenu = pathSegments[4] || "";
      if (idMenu) {
        const initialCollapseStates = getCollapseStates(props.routes, idMenu);
        setCollapseStates(initialCollapseStates);
        firstLoad.current = false;
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, props.routes]);

  const handleCloseSidebar = () => {
    if (windowWidth < 650) {
      document.documentElement.classList.remove("nav-open", false);
      window.dispatchEvent(new CustomEvent("toggleNav"));
    }
  };

  useEffect(() => {
    const pathSegments = location.pathname.split("/");
    const areaSelecionada = decodeURIComponent(pathSegments[2] || "");
    const menu = pathSegments[3] || "";
    const idMenu = pathSegments[4] || "";

    let menuPrincipal;

    if (!menu || !idMenu) {
      menuPrincipal = JSON.parse(localStorage.getItem("menus"))?.find(
        (item) => item.area === areaSelecionada && item.principal
      );
     
    }

    if (areaSelecionada !== areaLocalStorage) {
      localStorage.setItem("area", areaSelecionada);
      setAreaLocalStorage(areaSelecionada);
    }
    localStorage.setItem("menu", menu || menuPrincipal?.menu || "");
    localStorage.setItem("idMenu", idMenu || menuPrincipal?.id || "");
    localStorage.setItem("menu_nome", menu ||menuPrincipal?.menu || "");
  }, [location, props.routes, areaLocalStorage]);

  const area = (prop, key) => {
    if (prop.area === areaLocalStorage) {
      if (prop.views?.length > 0) {
        if (colapseStatus === prop.state) {
          collapseStates[prop.state] = !collapseStates[prop.state];
          setColapseStatus("");
        }
        return (
          <li
            //className={getCollapseInitialState(prop.views) ? "active" : ""}
            className={
              activeRoute(prop.path, prop.idMenu) +
              (prop.pro ? " active-pro" : "")
            }
            key={key}
          >
            <a
              href={prop.layout + prop.path}
              data-toggle="collapse"
              style={prop.position ? { paddingLeft: 10 * prop.position } : {}}
              aria-expanded={collapseStates[prop.state]}
              //to={prop.layout + prop.path}

              onClick={(e) => {
                e.preventDefault();
                props.history.push(prop.layout + prop.path);
                localStorage.setItem("menu_nome", prop.name);
                localStorage.setItem("idMenu", prop.idMenu);
                localStorage.setItem("menu_completo", prop.menuCompleto);
                setCollapseStates(collapseStates);
                setColapseStatus(prop.state);
                handleCloseSidebar();
              }}
            >
              {prop.icon !== undefined ? (
                <>
                  <p>
                    {prop.name}
                    <b
                      className="caret"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setCollapseStates(collapseStates);
                        setColapseStatus(prop.state);
                      }}
                    />
                  </p>
                </>
              ) : (
                <>
                  <span className="sidebar-mini-icon">{prop.mini}</span>
                  <span className="sidebar-normal">
                    {prop.name}
                    <b className="caret" />
                  </span>
                </>
              )}
            </a>
            <Collapse isOpen={collapseStates[prop.state]}>
              <ul className="nav">
                {prop.views.map((prop, key) => {
                  return area(prop, key);
                })}
              </ul>
            </Collapse>
          </li>
        );
      }
      return (
        <Fragment>
          <li
            className={
              activeRoute(prop.path, prop.idMenu) +
              (prop.pro ? " active-pro" : "")
            }
            key={key}
            //onClick={(e) => setState(e)}
          >
            <NavLink
              style={prop.position ? { paddingLeft: 10 * prop.position } : {}}
              to={prop.layout + prop.path}
              onClick={(e) => {
                e.preventDefault();
                localStorage.setItem("menu_nome", prop.name);
                localStorage.setItem("menu_completo", prop.menuCompleto);
                localStorage.setItem("idMenu", prop.idMenu);
                props.history.push(prop.layout + prop.path);
                handleCloseSidebar();
              }}
              className="nav-link"
              activeClassName="active"
            >
              <i className={prop.icon} />
              <p>{prop.name}</p>
            </NavLink>
          </li>
        </Fragment>
      );
    }
    if (prop.area === "Todas") {
      return (
        <li key={key}>
          <NavLink to={prop.path} className="nav-link" activeClassName="active">
            <i className={prop.icon} />
            <p>{prop.name}</p>
          </NavLink>
        </li>
      );
    }
    return null;
  };

  React.useEffect(() => {
    if (props.editMenu) window.location.reload();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.editMenu]);

  const getListMenus = (menu) => {
    var splitMenu = menu.menu.split("|");
    var menuName = splitMenu[splitMenu.length - 1];
    var menuFatherName = menu.menu.replace(menuName, "");
    return JSON.parse(localStorage.getItem("menus"))?.filter(
      (x) =>
        x.menu?.toUpperCase().includes(menuFatherName.toUpperCase()) &&
        x.area === menu.area &&
        ((splitMenu.length === 1 && !x.menu.includes("|")) ||
          (splitMenu.length > 1 &&
            splitMenu.length === x.menu.split("|").length))
    );
  };

  const existMenu = (menu, area) => {
    const menus = JSON.parse(localStorage.getItem("menus"));
    return menus?.some((x) => x.menu === menu && x.area === area);
  };

  const handleOrderMenu = (menu, from, to, isNew) => {
    var menusToEdit = [];
    var menus = getListMenus(menu);
    if (isNew) {
      menu.isNew = true;
      menus.push(menu);
    } else {
      menus.forEach((x) => {
        if (x.id === menu.id) x.menu = menu.menu;
        x.emails = menu.emails;
        x.grupos = menu.grupos;
        x.confidencial = menu.confidencial;
        x.principal = menu.principal;
      });
    }

    menus.reduce((prev, current, idx, self) => {
      if (
        Number(prev[idx - 1]?.ordem) === to &&
        Number(prev[idx - 1]?.ordem) > from
      ) {
        prev[idx - 1].ordemNew = Number(prev[idx - 1].ordem) - 1;

        menusToEdit.push(prev[idx - 1]);
      } else if (
        Number(prev[idx - 1]?.ordem) >= to &&
        Number(prev[idx - 1]?.ordem) < from
      ) {
        prev[idx - 1].ordemNew = Number(prev[idx - 1].ordem) + 1;

        menusToEdit.push(prev[idx - 1]);
      } else if (Number(prev[idx - 1]?.ordem) === from) {
        prev[idx - 1].ordemNew = menusToEdit.find((x) => x.ordemNew === to)
          ? to + 1
          : to;

        menusToEdit.push(prev[idx - 1]);
      } else if (
        Number(prev[idx - 1]?.ordem) < to &&
        Number(prev[idx - 1]?.ordem) > from
      ) {
        prev[idx - 1].ordemNew = Number(prev[idx - 1].ordem) - 1;

        menusToEdit.push(prev[idx - 1]);
      }
      if (idx === menus.length - 1) {
        if (Number(current.ordem) === to) {
          current.ordemNew = Number(current.ordem) - 1;

          menusToEdit.push(current);
        } else if (Number(current?.ordem) === from) {
          current.ordemNew = menusToEdit.find((x) => x.ordemNew === to)
            ? to + 1
            : to;

          menusToEdit.push(current);
        } else if (
          Number(current?.ordem) < to &&
          Number(current?.ordem) > from
        ) {
          current.ordemNew = Number(current.ordem) - 1;

          menusToEdit.push(current);
        } else if (
          Number(current?.ordem) > to &&
          Number(current?.ordem) < from
        ) {
          current.ordemNew = Number(current.ordem) - 1;

          menusToEdit.push(current);
        }
      }

      prev.push(current);
      return prev;
    }, []);
    saveMenus(menusToEdit);
  };

  const saveMenus = (menus) => {
    let area = localStorage.getItem("area");
    menus.forEach((m) => {
      if (!m.isNew) {
        let model = {
          params: {
            arg1: area,
            arg2: m.old ?? m.menu,
            arg3: m.menu,
            arg4: m.emails ?? m.usuarios,
            arg5: m.grupos || "",
            arg6: m.confidencial ?? m.confidencialAbs ?? false,
            arg7: m.principal || false,
            arg8: m.ordemNew,
            arg9: m.habilita_arquivo_local ? m.habilita_arquivo_local : false,
            arg10: m.diretorio_local
              ? m.diretorio_local
              : "P:\\sistemas\\reports",
          },
        };
        props.updateMenu(model);
      } else {
        let model = {
          params: {
            arg1: area,
            arg2: m.menu,
            arg3: m.emails ?? m.usuarios,
            arg4: m.grupos || "",
            arg5: m.confidencial ?? m.confidencialAbs ?? false,
            arg6: m.principal || false,
            arg7: m.ordemNew,
            arg8: m.habilita_arquivo_local ? m.habilita_arquivo_local : false,
            arg9: m.diretorio_local
              ? m.diretorio_local
              : "P:\\sistemas\\reports",
          },
        };
        props.createMenu(model);
      }
    });
  };

  // eslint-disable-next-line no-unused-vars

  return (
    <div
      className="sidebar"
      data-color={props.bgColor}
      data-active-color={props.activeColor}
    >
      <CadastrarMenu
        open={openMenu}
        setOpen={setOpenMenu}
        nameDefault={false}
        handleOrderMenu={handleOrderMenu}
        getListMenus={getListMenus}
        existMenu={existMenu}
      />
      <EditarMenu
        open={openEditMenu}
        setOpen={setOpenEditMenu}
        handleOrderMenu={handleOrderMenu}
        getListMenus={getListMenus}
      />
      <DeleteMenu open={openDeleteMenu} setOpen={setOpenDeleteMenu} />
      {/* {windowWidth < 650 && (
        <button onClick={handleCloseSidebar} style={{ position: "absolute", top: 0, right: 0, zIndex: 100 }}>
          X
        </button>
      )} */}
      <div className="logo">
        <a href={process.env.REACT_APP_URL} className="simple-text logo-mini">
          <div className="logo-img flex">
            <img src={logo} alt="react-logo" />
            <span className="pipe-logo">|</span>
            {areaLocalStorage}
          </div>
        </a>
      </div>
      <div className="sidebar-wrapper" ref={sidebar}>
        <Nav>
          {props.loading ? (
            <div style={{ textAlign: "center", color: "white" }}>
              <Spinner />
            </div>
          ) : (
            props.routes.map((prop, key) => {
              return area(prop, key);
            })
          )}
        </Nav>
      </div>
      {hasAcess && !isMobile ? (
        <div
          style={{ position: "fixed", bottom: 0, zIndex: 10000, width: 260 }}
        >
          <ButtonDropdown
            style={{ float: "right", width: 260 }}
            color="default"
            isOpen={dropdownOpen}
            toggle={() => setDropdownOpen(!dropdownOpen)}
          >
            <DropdownToggle color="default" caret>
              Editar Menu
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem
                style={{ width: 252 }}
                onClick={(e) => {
                  setOpenMenu(!openMenu);
                  //setUpdateCard(false);
                }}
              >
                Criar
              </DropdownItem>
              <DropdownItem divider />
              <DropdownItem
                onClick={(e) => {
                  setOpenEditMenu(!openEditMenu);
                  //setUpdateCard(false);
                }}
              >
                Editar
              </DropdownItem>
              <DropdownItem divider />

              <DropdownItem
                onClick={(e) => {
                  setOpenDeleteMenu(!openDeleteMenu);
                }}
              >
                Deletar
              </DropdownItem>
              <DropdownItem divider />
            </DropdownMenu>
          </ButtonDropdown>
        </div>
      ) : null}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    usuariosAdm: state.screening.screening.usuariosAdm,
    menuNew: state.screening.screening.menuNew,
    editMenu: state.screening.screening.editMenu,
  };
};

export default connect(mapStateToProps, {
  getUsuariosAdm,
  deleteMenu,
  updateMenu,
  createMenu,
})(Sidebar);
